import getErrorByKeyName from "@/core/utils/getErrorByKeyName";
import { Field } from "@/core/types/types";

function useFieldError(errors: Record<string, any>, field: Field) {
  const error = getErrorByKeyName(errors, field.key);
  const hasError = !!error;
  const errorMessage = error?.message;
  const errorTranslationKey =
    field.properties?.errorTranslationKey || field.key;

  return { hasError, errorMessage, errorTranslationKey };
}

export { useFieldError };
